/* eslint-disable jsx-a11y/anchor-is-valid */
import {sweetAlert} from '../../../../utils/UniversalFunction';
import e1 from "../../../../img/e1.png";
import React, { Component } from "react";
import config from "../../../../config/config.json";
import { authenticationService } from "../../../../_services/authentication";
import axios from "axios";
const currentUser = authenticationService.currentUserValue;

export default class AssignSubAdminComponent3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      selectedName: this.props.assignedUserName,
      assignedUserId: this.props.assignedUserId,
      removeHeading: this.props.removeHeader ?? false,
      id: this.props.idd ?? false,
      submitted: false,
      selected: "",
      dueDate: "",
      items: [],
      filteredData: [],
      tableName: this.props.tableName,
    };

    this.handleChange = this.handleChange.bind(this);
    this.search = this.search.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.serverRequest = this.serverRequest.bind(this);
    
  }

 

  search(event) {
    const target = event.target;
    const value = target.value.toLowerCase();
    const filtered = this.state.items.filter((entry) =>
      Object.values(entry).some(
        (val) => typeof val === "string" && val.toLowerCase().includes(value)
      )
    );
    this.setState({ filteredData: filtered });
  }

  handleChange(event) {
    const target = event.target;
    const namee = event.target.getAttribute("data-name");
    const name = target.name;
    const value = target.value;
    this.setState({
      [name]: value,
      selectedName: namee,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ submitted: true });
    const { selected, dueDate, tableName, id } = this.state;
    const headers = {
      Authorization: `Bearer ${currentUser.data.token}`,
      Accept: "application/json",
    };
    axios
      .post(
        config.API_URL + "assignSubAdmin",
        {
          assigned_user_id: selected,
          dueDate: dueDate,
          tableName: tableName,
          id: id,
        },
        { headers }
      )
      .then((response) => {
        sweetAlert('success',response.data.message);	
        this.serverRequest()
      })
      .catch(function (error) {
        if (error.response) {
            sweetAlert('error',error.response.data.message);
        }
      });
  }

  serverRequest(){
    let token = JSON.parse(localStorage.getItem("currentUser")).data.token;
    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
    fetch(config.OLD_API_URL + `getCompanySubAdmin?limit=100&skip=0`, {
      headers,
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result.data,
            options: [],
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );

    //   Get Answers Api
    axios
      .post(
        config.API_URL + "getAssignedUserId",
        { tableName: this.state.tableName },
        { headers }
      )
      .then((response) => {
        this.setState({
          assignedUserId: response?.data?.data[0]?.company_sub_admin_id,
        });
      })
      .catch(function (error) {
        if (error.response) {
          sweetAlert('error',error.message);
        }
      });
  }

  componentDidMount() {
  this.serverRequest()
  }

  render() {
    const {
      items,
      selectedName,
      filteredData,
      assignedUserId,
      removeHeading,
    } = this.state;

    let fullName = items
      .filter((e) => e.id === assignedUserId)
      .map((e) => e.firstName + " " + e.lastName);

    let finalArray = [];
    finalArray = filteredData.length > 0 ? filteredData : items;
    return (
      <>
        Supplier :
        <div>
          <div className="d-flex dropdown"
          style={{ margin: "-8px 8px" }}
          >
            <input
              className="btn btn-secondary dropdown-toggle"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              placeholder={selectedName != null ? selectedName : fullName[0]}
            />

            <div
              className="dropdown-menu border-0 shadow"
              aria-labelledby="dropdownMenuLink"
              style={{margin:"0 -10px"}}
            >
              <div className="d-head">
                <div className="mb-3">
                  {removeHeading === false && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label"
                    >
                      Supplier:
                    </label>
                  )}
                  <input
                    type="text"
                    className="form-control mt-2"
                    onKeyDown={this.search}
                    id="exampleFormControlInput1"
                    placeholder="Search here"
                  />
                </div>
              </div>
              <ul>
                {finalArray.map((item, key) => (
                  <li key={key}>
                    <a className="dropdown-item py-2 px-0" href="#">
                      <div className="form-check check-form d-flex">
                        <div className="form-d">
                          <img src={e1} alt="" />
                          <label
                            className="form-check-label"
                            htmlFor="exampleRadios1"
                          >
                            {item.firstName + " " + item.lastName}
                          </label>
                        </div>
                        <input
                          className="form-check-input"
                          onChange={this.handleChange}
                          type="radio"
                          // value={selected}
                          name="selected"
                          id="exampleRadios1"
                          data-name={item.firstName + " " + item.lastName}
                          value={item.id}
                        />
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}
